export enum Status {
  Active = "1",
  Inactive = "0",
}
